<template>
  <el-card class="box-card" style="margin-bottom: 10px">
    <div slot="header" class="clearfix">
      <span>{{ "见证情况" }}</span>
    </div>
    <template>
      <el-table :data="detail.situationDetailList" :border="true">
        <el-table-column fixed type="index" header-align="center" align="center" label="序号" width="60">
        </el-table-column>
        <el-table-column prop="contentName" header-align="left" align="left" min-width="200" label="见证内容">
        </el-table-column>
        <el-table-column prop="isOk" header-align="center" align="center" min-width="50" label="见证情况">
          <template slot-scope="scope">
            <span v-if="showDetail">{{ scope.row.isOk ? '已见证' : '未见证' }}</span>
            <el-checkbox v-else v-model="scope.row.isOk">已见证</el-checkbox>
          </template>
        </el-table-column>
        <el-table-column prop="situationRemark" header-align="left" align="left" min-width="200" label="情况记录">
          <template slot-scope="scope">
            <span v-if="showDetail">{{ scope.row.situationRemark }}</span>
            <el-input v-else v-model="scope.row.situationRemark" type="textarea"></el-input>
          </template>
        </el-table-column>
      </el-table>
    </template>
  </el-card>
</template>

<script>
export default {
  props: {
    projectInfo: {
      type: Object,
      default: () => { }
    },

  },
  watch: {
    projectInfo: {
      immediate: true,
      handler(val) {
        this.getDetail(val);
      },
      deep: true
    },
  },
  data() {
    return {
      showDetail: false,
      detail: {
        situationDetailList: [],
      },
    }
  },
  activated() {
  },
  methods: {
    indexMethod(index) {
      return (this.pageIndex - 1) * this.pageSize + index + 1
    },

    getDetail(projectInfo) {
      if (projectInfo.entityId || (projectInfo.tenderProjectCode && projectInfo.datasetCode)) {
        // 下面接口404，应后端要求先注释掉
        // this.$http.post(`/situation/detailForTrade?tenderProjectCode=${projectInfo.tenderProjectCode}&dataSetCode=${projectInfo.datasetCode}&entityId=${projectInfo.entityId}`, {
        //   id: this.id,
        // }).then((res) => {
        //   this.detail = res.data;
        //   if (res.data.isSave == 1) this.showDetail = true;
        // })
      }
    },

    submitCallback() {
      this.$http.post(`/situation/save`, {
        ...this.detail
      }).then((res) => { })
    },
  }
}
</script>

<style lang="less" scoped>
.dataWrapper {
  position: relative;
  border-bottom: 1px solid #ebeef5;
  margin-bottom: 10px;

  &:last-child {
    border-bottom: none;
  }

  .iconToolbar-left {
    font-weight: bold;
    color: #fff;
    text-align: center;
    padding-top: 3px;
    position: absolute;
    top: 10px;
    left: 0px;
    width: 32px;
    height: 32px;
    background: url("../../assets/img/bookmark.png")no-repeat;
  }
}

.dataWrapper:last-child {
  border-bottom: none;
}
</style>
